import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * The backend OAuth callback redirects to `/{current domain}/oauth`
 * with oauth_success / oauth_error query params. Forward to the connect page
 * so the flow resumes in one place.
 */
function OAuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    navigate('/connect', { replace: true, state: Object.fromEntries(searchParams.entries()) });
  }, [navigate, searchParams]);

  const provider = searchParams.get('oauth_provider');
  const label = provider === 'google-ads' ? 'Google Ads' : provider === 'universal-ads' ? 'Universal Ads' : provider === 'facebook' ? 'Meta' : 'your account';

  return (
    <div className="center-screen">
      <div className="agent-turn">
        <span className="agent-avatar">A</span>
        <div><strong>Connecting {label}…</strong><p>I’m securing your campaign access.</p></div>
      </div>
    </div>
  );
}

export default OAuthCallbackPage;
